import React, { Suspense } from "react";
import SunnySpinner from "ui/SunnySpinner";

export default function suspenseWrapper(page: JSX.Element) {
  return (
    <Suspense fallback={<SunnySpinner fullPage={true} />}>{page}</Suspense>
  );
}
